<template>
    <div class="img-verify" data-automation="imgVerify">
        <img class="img-verify-src" :src="imgSrc" @click="getKaptcha" />
    </div>
</template>

<script>
export default {
  name: 'ImgVerify',
  model: {
    prop: 'value', // 要存在于props
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      getKaptchaing: false,
      timer: null,
      code: this.value,
      imgSrc: ''
    };
  },
  created() {
    this.getKaptcha();
  },
  methods: {
    /**
         * 图形验证码
         */
    getKaptcha() {
      if (this.getKaptchaing) return;
      this.getKaptchaing = true;

      this.$api.workOrder
        .getKaptcha({}, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000 && res.data) {
            const data = res.data;
            this.code = data.substring(0, 6);
            this.imgSrc = data.substring(7);
          }
        })
        .finally(() => {
          this.timer = setTimeout(() => {
            this.getKaptchaing = false;
            clearTimeout(this.timer);
            this.timer = null;
          }, 500);
        });
    }
  },
  watch: {
    // 这里检测data中的值，一旦发生变化就提交事件到父组件
    code: {
      handler(newVal) {
        this.$emit('change', newVal);
      }
    },
    value: {
      handler(newval) {
        this.code = newval;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.img-verify {
    position: relative;
    display: block;
    width: 98px;
    height: 32px;

    .img-verify-src {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        cursor: pointer;
    }
}
</style>
